export const DrivingLicenceOptionsTypes = [
  { value: 'Full UK Driving Licence', label: 'Full UK Driving Licence' },
  { value: 'Provisional UK Driving Licence', label: 'Provisional UK Driving Licence' },
  { value: 'European Driving Licence', label: 'European Driving Licence' },
  { value: 'International Driving Licence', label: 'International Driving Licence' },
  { value: 'No Driving Licence', label: 'No Driving Licence' }
]

export const SimpleDrivingLicenceOptions = [
  { value: 'Full UK Driving Licence', label: 'Full UK' },
  { value: 'Provisional UK Driving Licence', label: 'Provisional UK' },
  { value: 'European Driving Licence', label: 'European' },
  { value: 'International Driving Licence', label: 'International' },
  { value: 'No Driving Licence', label: 'None' }
]
